import { jsx as a } from "@emotion/react/jsx-runtime";
import s, { radioClasses as r } from "@mui/material/Radio";
import i from "@mui/material/RadioGroup";
const u = r, d = ({ ...o }) => /* @__PURE__ */ a(s, { ...o });
d.displayName = "Radio";
const p = ({ ...o }) => /* @__PURE__ */ a(i, { ...o });
p.displayName = "RadioGroup";
export {
  d as R,
  p as a,
  u as r
};
